import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyUs from './components/WhyUs';
import Mission from './components/Mission';
import Works from './components/Works';
import Services from './components/Services';
import Team from './components/Team';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import PrivacyPolicy from './components/PrivacyPolicy';
import CustomCursor from './components/CustomCursor';

const HomePage: React.FC = () => (
  <>
    <Hero />
    <WhyUs />
    <Mission />
    <Works />
    <Services />
    <Team />
    <Testimonials />
    <Contact />
    <Footer />
    <CookieBanner />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="bg-[#080808] text-white overflow-x-hidden">
        <CustomCursor />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={
            <>
              <PrivacyPolicy />
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
